import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Observable } from 'rxjs';
import { Reservation } from '../models/reservation.model';
import { Cookies } from 'typescript-cookie';
import { GeneralResponse } from '@core/models';
import { User } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ReservationService {
  private apiService = inject(ApiService);

  getReservations(formData: any): Observable<Reservation[]> {
    return this.apiService.getById('', formData);
  }
  getReservationsTyope(): Observable<any> {
    return this.apiService.get<any>('reservationStatus');
  }

  postReservation(body: any) {
    const {
      type,
      startdate,
      enddate,
      workplaceid,
      floorId,
      workplacetype,
      worker,
    } = body;
    const business = Cookies.get('bussinesId');
    if (type == 'normal') {
      return this.apiService.post(
        `reservation?type=${type}&startdate=${startdate}&enddate=${enddate}&workplaceid=${workplaceid}&businessid=${business}&workerid=${worker}`,
        {}
      );
    } else {
      return this.apiService.post(
        `reservation?type=${type}&startdate=${startdate}&enddate=${enddate}&workplaceid=${workplaceid}&businessid=${business}&workerid=${worker}&floorid=${floorId}&typeId=${workplacetype}`,
        {}
      );
    }
  }

  getAllUser(businessId: string): Observable<GeneralResponse<User[]>> {
    return this.apiService.get<User[]>(
      `worker/clients?businessid=${businessId}`
    );
  }
  deleteReservations(id: string): Observable<GeneralResponse<any>> {
    return this.apiService.delete(`reservation`, id);
  }
}
